import HttpRequest from "@/plugins/http";

const request = new HttpRequest({
  // baseURL: "/roomit/platform/dev/v1",
  baseURL: "https://air.mycwt.com.cn/triprule/api/v1",
});

const axios = request.request();

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getTripRules(params) {
  return axios.get("/TripRule/query", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getTripRule(params) {
    return axios.get("/TripRule/" + params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function addTripRule(params) {
  return axios.put("/TripRule", params);
}
  